import { isRouteErrorResponse } from 'react-router-dom';

export const getErrorType = (error: unknown) => {
  if (!isRouteErrorResponse(error)) return 'Application error';

  return error.statusText ? `${error.status} ${error.statusText}` : `${error.status}`;
};
